import { cn } from '@/lib/utils'

type Size = 'sm' | 'md' | 'lg'

const SCALE: Record<Size, number> = {
  sm: 0.6,
  md: 0.9,
  lg: 1.2,
}

interface EtainablSpinnerProps {
  size?: Size
  /** Screen-reader-only label, not rendered visually. */
  srLabel?: string
  className?: string
}

export function EtainablSpinner({ size = 'md', srLabel = 'Loading', className }: EtainablSpinnerProps) {
  const scale = SCALE[size]
  return (
    <div
      className={cn('flex items-center justify-center', className)}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      style={{ ['--etn-spinner-scale' as any]: scale }}
      role="status"
      aria-live="polite"
    >
      <div className="etn-spinner">
        <div className="left" />
        <div className="right" />
      </div>
      <span className="sr-only">{srLabel}</span>
    </div>
  )
}

// Centred full-page variant for route guards / detail-pane loaders.
export function FullPageSpinner({ srLabel }: { srLabel?: string }) {
  return (
    <div className="flex h-full min-h-[60vh] items-center justify-center p-8">
      <EtainablSpinner size="lg" srLabel={srLabel} />
    </div>
  )
}
